import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Common/Reducers/wrapperReducer";
import LedgerDetail from "./LedgerDetail";
import LedgerSnapShot from "./LedgerSnapShot";
import snapShotExtention from "./snapShotExtention";
import contractNote from "./ContractNote";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
export default combineReducers({
    snapShot: createNamedWrapperReducer(LedgerSnapShot, ERevampReportReducers.LEDGER_SNAPSHOT),
    detail: createNamedWrapperReducer(LedgerDetail, ERevampReportReducers.LEDGER_DETAILS),
    snapShotExtention: createNamedWrapperReducer(snapShotExtention, ERevampReportReducers.LEDGER_SNAPSHOT_EXTENTION),
    contractNote: createNamedWrapperReducer(contractNote, ERevampReportReducers.LEDGER_CONTRACT_NOTE),
});
